import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/verified.svg'


const _withScopeId = n => (_pushScopeId("data-v-0b1311f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-py-6 header-text" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "tw-text-left tw-text-[22px] tw-font-normal tw-leading-6 tw-tracking-[0.15px] tw-text-[#0C0F4A]" }, " Estimate Overview ")
], -1))
const _hoisted_2 = { class: "estimate-received-preview" }
const _hoisted_3 = { class: "estimate-received-preview__content" }
const _hoisted_4 = { class: "left_block" }
const _hoisted_5 = { class: "left_block__header" }
const _hoisted_6 = { class: "property__icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "verfied_icon"
}, null, -1))
const _hoisted_9 = { class: "left_block__header__content" }
const _hoisted_10 = { class: "chips_wrapper" }
const _hoisted_11 = { class: "estimate_chip" }
const _hoisted_12 = { class: "tw-pl-3 tw-pb-2 tw-box-border tw-flex tw-flex-col tw-gap-4 tw-w-full tw-max-w-full lg:tw-w-full lg:tw-pr-0 lg:tw-pl-0" }
const _hoisted_13 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_14 = { class: "tw-w-full tw-flex tw-items-center tw-justify-start" }
const _hoisted_15 = { class: "tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-8" }
const _hoisted_16 = { class: "right_block" }
const _hoisted_17 = { class: "right_block__top" }
const _hoisted_18 = { class: "estimate-received-previ tw-w-full tw-flex tw-flex-col tw-gap-4" }
const _hoisted_19 = {
  key: 0,
  class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-rounded-[10px] tw-px-3 tw-py-1 tw-box-border tw-bg-[#f454540d] tw-border-solid tw-border tw-border-[rgba(255,165,0,1)]"
}
const _hoisted_20 = { class: "tw-text-sm tw-border-[rgba(255,165,0,1)] tw-text-left tw-bg-[rgba(255,165,0,0.2) tw-w-[calc(100%-50px)] tw-max-w-full" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "estimate-received-preview__container tw-flex tw-items-start tw-justify-between tw-py-4 tw-box-border tw-border-[0] tw-border-b-[1px] tw-border-[#C5D2F2] tw-border-solid md:!tw-pt-0" }, null, -1))
const _hoisted_24 = {
  key: 1,
  class: "tw-gap-10 tw-flex xl:tw-gap-5 lg:tw-flex-col md:!tw-pb-28"
}
const _hoisted_25 = { class: "tw-flex tw-flex-col tw-gap-4 tw-w-[340px] tw-max-w-full lg:tw-w-full" }
const _hoisted_26 = { class: "tw-flex tw-flex-col tw-gap-4 tw-items-start" }
const _hoisted_27 = { class: "lg:tw-flex tw-items-center tw-gap-4 tw-hidden sm:tw-flex-col" }
const _hoisted_28 = { class: "modal_wrapper" }
const _hoisted_29 = { class: "main" }
const _hoisted_30 = { class: "loader__content" }
const _hoisted_31 = { class: "switching-text" }
const _hoisted_32 = { class: "loader__icon" }
const _hoisted_33 = ["src"]

import { reactive, computed, getCurrentInstance } from "vue";

import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import SubContractorList from "@/modules/project/components/common/SubContractorList.vue";
import LabelWithValue from "@/core/components/common/LabelWithValue.vue";
import EstimateReceivedSummaryCard from "@/modules/project/components/common/EstimateReceivedSummaryCard.vue";
import EstimateReceivedSummaryDetails from "@/modules/project/components/common/EstimateReceivedSummaryDetails.vue";
import { useRouter } from "vue-router";

import { ref } from "vue";
import ServiceAgreementModal from "@/modules/jobs/components/modal/ServiceAgreementModal.vue";
import AcceptProjectEstimateModal from "@/modules/project/modal/AcceptProjectEstimateModal.vue";
import RejectProjectEstimateModal from "@/modules/project/modal/RejectProjectEstimateModal.vue";

import { useStore } from "vuex";
import { USER_STORE } from "@/store/modules/user";
import projectEstimationService from "@/core/services/project-estimation.service";
import {
  AgreeTermsConsumerDisclosure,
  EstimateTypeForDeposit,
} from "@/core/enums/estimateEnum";
import EstimateDetailsModal from "@/modules/project/modal/EstimateDetailsModal.vue";

import EstimateApproveModal from "@/modules/project/modal/EstimateApproveModal.vue";
import { PROJECT_STORE } from "@/store/modules/project";

import {
  getCombineSameProjectReview,
  setDirectStoragePathToImage,
} from "@/core/utils/common";
import { WORKSTATION } from "@/store/modules/workstation";
import ErrorRedIcon from "@/core/components/icons/ErrorRedIcon.vue";
import { useRoute } from "vue-router";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { reviewRatingState } from "@/core/models/project-rating";
import { REVIEW_RATING_STORE } from "@/store/modules/review-rating";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RaiseEstimatePreview',
  props: {
  details: {
    type: Object,
  },
},
  emits: ["start-registration"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const router = useRouter();
const route = useRoute();
const store = useStore();
const loading = ref(false);
const isAcceptEstimate = ref(false);
const isRejectEstimate = ref(false);
const isEstimateLoading = ref(false);
const isOpenServiceAgreementModal = ref(false);
const isOpenEstimateDetailsModal = ref(false);
const isEstimateApproved = ref(false);
const user = computed(() => store.getters[`${USER_STORE}/user`]);
const switchingText = ref("Loading...");
const currentSelectedTab = ref({ name: "tab1" });
const acceptEstimateLoader = ref(false);
const tabListItems = ref([
  { name: "tab1" },
  { name: "tab2" },
  { name: "tab3" },
]);
const currentTab = ref("Job Details");
const tabList = [
  {
    title: "Job Details",
    icon: "mdi-magnify",
  },

  {
    title: "Schedule",
    icon: "mdi-file-document",
  },
];

const onToggleChart = (isShowChart) => {
  if (isShowChart) {
    currentTab.value = "Schedule";
  } else {
    currentTab.value = "Job Details";
  }
};
const projectName = computed(() => props.details?.project?.name || "");
const workStationName = computed(
  () =>
    props.details?.project?.projectEstimateAcceptDetails?.workStation?.name ||
    ""
);
const projectEstimate = computed(() => {
  return {
    ...props.details,
    projectEstimateCreator: {
      ...props.details?.workStation?.user,
      workStation: props.details?.workStation,
    },
    projectStages: props.details?.estimationPhase,
  };
});
const internalInstance = getCurrentInstance();

const projectDetail = computed(() => {
  return {
    ...props.details?.project,
    projectCreator: {
      firstName: user.value?.firstName,
      lastName: user.value?.lastName,
    },
  };
});

const contractorDetails = computed(() => {
  return props.details?.workStation;
});

const isProjectEstimateIdPresent = computed(
  () => !!props.details?.project?.projectEstimateId
);
const isIdMatching = computed(() => {
  const routeId = route.params.estimateId;
  const projectEstimateId = props.details?.project?.projectEstimateId;
  return routeId == projectEstimateId;
});

const onClickBackEstimateButton = () => {
  router.push(`/project-details/${props?.details?.project?.refId}`);
};

const onClickRejectEstimate = () => {
  //   isRejectEstimate.value = true;
  emits("start-registration");
};

const onClickAcceptEstimate = () => {
  //   isAcceptEstimate.value = true;
  emits("start-registration");
};
const onClickRaiseQuestion = () => {
  //   isAcceptEstimate.value = true;
  emits("start-registration");
};

const onConfirmEstimate = async () => {
  isAcceptEstimate.value = false;

  isOpenServiceAgreementModal.value = true;
};

const onCloseRejectEstimate = () => {
  isRejectEstimate.value = false;
};

const onCloseAcceptEstimate = () => {
  isAcceptEstimate.value = false;
};

const onClickServiceAgreementModal = () => {
  isOpenServiceAgreementModal.value = true;
};
const onConfirmRejectEstimate = async (payload: any) => {
  try {
    const data = await projectEstimationService.rejectEstimate(
      props.details?.id,
      payload
    );
  } catch (error) {
    console.log("error", error);
  } finally {
    isRejectEstimate.value = false;
    router.push(`/project-details/${props?.details?.project?.refId}`);
  }
};
const onConfirmServiceAgreement = async () => {
  isOpenServiceAgreementModal.value = false;
  isOpenEstimateDetailsModal.value = true;
};

const onCloseServiceAgreementModal = () => {
  isOpenServiceAgreementModal.value = false;
};

const onCloseEstimateDetailsModal = async () => {
  isOpenEstimateDetailsModal.value = false;
  isEstimateLoading.value = true;

  try {
    loading.value = true;
    setTimeout(() => {
      switchingText.value = "Loading...";
      currentSelectedTab.value = tabListItems.value[0];
    }, 1000);
    const payload = { status: AgreeTermsConsumerDisclosure.ACCEPTED };
    (await projectEstimationService.submitStatusWithEstimateUpdate(
      props.details?.project?.id,
      props.details?.id,
      payload
    )) as any;

    isEstimateApproved.value = true;
  } catch (error) {
    console.log("error ", error);
    isEstimateApproved.value = false;
    router.go(-1);
  } finally {
    setTimeout(() => {
      switchingText.value = "Loading...";
      currentSelectedTab.value = tabListItems.value[1];
    }, 2000);

    setTimeout(() => {
      switchingText.value = "Loading...";
      currentSelectedTab.value = tabListItems.value[2];
      loading.value = false;
    }, 5000);
  }
};
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const projectCreatorDetails = computed(() => {
  return {
    ...projectDetail.value,
    userWorkstation: activeUserWorkstation.value,
  };
});
const getTradeEstimateDetails = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/getTradeEstimateDetails`]
);
const onClickBackProject = () => {
  // project refId
  isEstimateApproved.value = false;
  router.push(`/project-details/${props?.details?.project?.refId}`);

  store.dispatch(
    `${PROJECT_STORE}/setProjectRedirectTabName`,
    "project-overview"
  );
};
const goToDetailPage = () => {
  router.push(`/trade-estimates/${props.details?.project?.projectEstimateId}`);
};
const getAllProjectReviewList = computed<
  reviewRatingState["allProjectReviewList"]
>(() => store.getters[`${REVIEW_RATING_STORE}/getAllProjectReviewList`]);

const combineSameProjectReview = computed(() =>
  getCombineSameProjectReview(getAllProjectReviewList.value)
);
const getAverageOfAllProjectReview = computed(() => {
  const totalAvg = combineSameProjectReview.value.reduce(
    (totalRating: number, review: any) => {
      totalRating += review.totalAvg || 0;
      return totalRating;
    },
    0
  );
  return totalAvg
    ? Math.round((totalAvg * 100) / combineSameProjectReview.value.length) / 100
    : totalAvg;
});
const estimateBadge = computed(() => {
  if (props.details?.depositType === EstimateTypeForDeposit.Initial_Estimate)
    return "Initial Estimate";
  else if (
    props.details?.depositType === EstimateTypeForDeposit.Fixed_Cost_Estimation
  )
    return "Fixed Cost Estimation";
  else if (
    props.details?.depositType ===
    EstimateTypeForDeposit.Variable_Cost_Estimation
  )
    return "Variable Cost Estimation";
  else return "";
});

const contractorWorkStationUrl = computed(() => {
  return setDirectStoragePathToImage(contractorDetails.value?.profileImage);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_tabs, {
      class: "tab-list",
      "align-tabs": "center",
      stacked: "",
      modelValue: currentTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTab).value = $event))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, (item, index) => {
          return _createVNode(_component_v_tab, {
            key: index,
            value: item.title
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.icon), 1)
                ]),
                _: 2
              }, 1024),
              _createTextVNode(" " + _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["value"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (contractorWorkStationUrl.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: contractorWorkStationUrl.value,
                    alt: ""
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createBlock(UserProfileLogo, {
                    key: 1,
                    userName: contractorDetails.value?.name
                  }, null, 8, ["userName"])),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h6", null, _toDisplayString(contractorDetails.value?.name), 1),
              _createElementVNode("p", null, _toDisplayString(contractorDetails.value?.user?.userBusinessDetails?.type), 1),
              _createVNode(_component_v_rating, {
                class: "rating_wrapper",
                "active-color": "orange",
                color: "rgba(12, 15, 74, 0.26)",
                "empty-icon": "mdi-star",
                readonly: "",
                "model-value": getAverageOfAllProjectReview.value
              }, null, 8, ["model-value"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(estimateBadge.value), 1),
                _createVNode(_component_v_icon, { icon: "mdi-information" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(Text, { variant: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.details?.project?.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(LabelWithValue, {
                  justifyStart: true,
                  noBg: true,
                  data: __props.details?.project?.refId,
                  label: "Project ID:"
                }, null, 8, ["data"])
              ])
            ]),
            _createVNode(_component_v_divider),
            _createVNode(EstimateReceivedSummaryCard, {
              selectedEstimate: __props.details,
              isClientRaiseEstimate: true,
              class: "estimate__received__card",
              onOnToggleChart: onToggleChart,
              isShowGanttChart: currentTab.value === 'Schedule'
            }, null, 8, ["selectedEstimate", "isShowGanttChart"])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_btn, {
              class: "button button-purple-border",
              disabled: isProjectEstimateIdPresent.value,
              onClick: onClickAcceptEstimate,
              width: "100%"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Accept Estimate")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_v_btn, {
              class: "button button-purple",
              disabled: isProjectEstimateIdPresent.value,
              onClick: onClickRejectEstimate,
              width: "100%"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Raise Questions")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createVNode(EstimateReceivedSummaryDetails, {
            selectedEstimate: __props.details,
            class: "estimate_received__data"
          }, null, 8, ["selectedEstimate"])
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_18, [
      (isProjectEstimateIdPresent.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(ErrorRedIcon, { class: "tw-w-[30px] tw-h-[30px]" }),
            _createElementVNode("p", _hoisted_20, [
              (!isIdMatching.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                    _createTextVNode(" An estimate for the project \""),
                    _createElementVNode("strong", null, _toDisplayString(projectName.value), 1),
                    _createTextVNode("\" has already been submitted by the "),
                    _createElementVNode("strong", null, _toDisplayString(workStationName.value), 1),
                    _createTextVNode(" workstation. "),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _withModifiers(goToDetailPage, ["prevent"])
                    }, " View Esimate")
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _createTextVNode(" An estimate for the project \""),
                    _createElementVNode("strong", null, _toDisplayString(projectName.value), 1),
                    _createTextVNode("\" has already been accepted. ")
                  ]))
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_23,
      (__props.details)
        ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                (
              __props.details?.inviteContractors && __props.details?.inviteContractors?.length
            )
                  ? (_openBlock(), _createBlock(SubContractorList, {
                      key: 0,
                      class: "desktop__wrapper lg:tw-hidden",
                      subContractorDetailsList: __props.details?.inviteContractors
                    }, null, 8, ["subContractorDetailsList"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(Button, {
                class: "!tw-w-[200px] sm:!tw-w-full",
                variant: "secondary",
                label: "Accept Estimate",
                onClick: onClickAcceptEstimate
              }),
              _createVNode(Button, {
                class: "!tw-w-[200px] sm:!tw-w-full",
                label: "Raise Questions",
                onClick: onClickRaiseQuestion
              })
            ]),
            _createVNode(SubContractorList, {
              class: "mobile__wrapper tw-hidden lg:tw-block lg:tw-text-left",
              subContractorDetailsList: __props.details?.inviteContractors
            }, null, 8, ["subContractorDetailsList"])
          ]))
        : _createCommentVNode("", true),
      (isAcceptEstimate.value)
        ? (_openBlock(), _createBlock(AcceptProjectEstimateModal, {
            key: 2,
            isLoading: acceptEstimateLoader.value,
            onOnSave: onConfirmEstimate,
            onOnClose: onCloseAcceptEstimate
          }, null, 8, ["isLoading"]))
        : _createCommentVNode("", true),
      (isOpenServiceAgreementModal.value)
        ? (_openBlock(), _createBlock(ServiceAgreementModal, {
            key: 3,
            project: projectCreatorDetails.value,
            projectEstimate: projectEstimate.value,
            type: "property",
            onOnConfirm: onConfirmServiceAgreement,
            onOnClose: onCloseServiceAgreementModal
          }, null, 8, ["project", "projectEstimate"]))
        : _createCommentVNode("", true),
      (isRejectEstimate.value)
        ? (_openBlock(), _createBlock(RejectProjectEstimateModal, {
            key: 4,
            projectId: __props.details?.project?.id,
            projectEstimateId: __props.details?.id,
            onOnConfirm: onConfirmRejectEstimate,
            onOnCancel: onCloseRejectEstimate
          }, null, 8, ["projectId", "projectEstimateId"]))
        : _createCommentVNode("", true),
      (isOpenEstimateDetailsModal.value)
        ? (_openBlock(), _createBlock(EstimateDetailsModal, {
            key: 5,
            onOnClose: onCloseEstimateDetailsModal,
            projectEstimateId: __props.details?.id
          }, null, 8, ["projectEstimateId"]))
        : _createCommentVNode("", true),
      (isEstimateApproved.value)
        ? (_openBlock(), _createBlock(EstimateApproveModal, {
            key: 6,
            estimateData: __props.details,
            onOnBackProject: onClickBackProject,
            onOnDeposit: onClickBackProject
          }, null, 8, ["estimateData"]))
        : _createCommentVNode("", true),
      (isEstimateLoading.value)
        ? (_openBlock(), _createBlock(_component_v_dialog, {
            key: 7,
            width: "500px",
            modelValue: loading.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loading).value = $event)),
            class: "modal_box action-modal",
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("main", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(switchingText.value), 1),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("img", {
                        src: require('@/assets/icons/estimate-loader.svg'),
                        alt: ""
                      }, null, 8, _hoisted_33)
                    ]),
                    _createVNode(_component_v_stepper, {
                      class: "onboard-stepper",
                      modelValue: currentSelectedTab.value.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSelectedTab.value.name) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabListItems.value, (step, index) => {
                              return (_openBlock(), _createBlock(_component_v_stepper_item, {
                                class: "onboard-stepper__item",
                                key: index,
                                value: step.name
                              }, null, 8, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})